/**
 * @name Backup
 * @description Componente para agregar, editar y eliminar backup en configuración de perfil
 * @author Gerardo de León
 */

import React, { Component } from 'react';
import i18n from 'i18next';
import PropTypes from 'prop-types';
import moment from 'moment';
import styled from 'styled-components';
import { trackPromise } from 'react-promise-tracker';

import { Environment } from '@tycommon/config';
import { DataGrid, EmployeeDetail, FiltersExpansion, LoadingWrapper } from '@tycommon/components';
import { BackupService, EmployeeService, NotificationsService, SnackbarService, ResponseHandlerService } from '@tycommon/services';
import { Icons, MUI, Typography } from '@tycommon/styles';

// Components
import CommentLog from './components/comment-log';
import BackupDialog from './components/backup.dialog';
import CancelDialog from './components/cancel.dialog';

class Backup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      employeesList: [],
      selectedBackup: [],
      gridConfig: {
        rows: [],
        columns: [
          { id: 'Id', label: i18n.t('Id'), visible: false, filter: null },
          { id: 'IdEmpleadoBackup', label: i18n.t('Id'), visible: false, filter: null },
          { type: 'complex', id: ['FotoBackup', 'NombreBackup', 'PuestoBackup'], label: i18n.t('Backup'), visible: true, filter: null, sort: false },
          { id: 'FechaInicio', label: i18n.t('GenericMessages.startDate'), visible: true, filter: 'ShortDateFilter', sort: false },
          { id: 'FechaFin', label: i18n.t('GenericMessages.endDate'), visible: true, filter: 'ShortDateFilter', sort: false },
          { id: 'Estatus', label: i18n.t('GenericMessages.status'), visible: true, filter: null, sort: true },
        ],
        canAdd: true,
        canEdit: false,
        canDelete: false,
        canSelect: true,
      },
      showBackupDialog: {
        data: {},
        open: false
      },
      showCancelDialog: {
        data: {},
        open: false
      },
    };
  }

  componentDidMount() {
    this.getBackup();
  }

  // Consulta los backup del usuario
  getBackup = () => {
    const { gridConfig } = this.state;

    trackPromise(
      BackupService.get()
        .then((response) => {
          // NOTA: Se resta un día a la Fecha Fin para mostrarla de forma correcta y se ordenan los comentarios por fecha.
          response.map((item) => {
            item.FechaFin = moment(item.FechaFin).subtract(1, 'days');
            item.Comentarios = item.Comentarios.sort((a, b) => new Date(a.Fecha) - new Date(b.Fecha));
          });
          gridConfig.rows = response;
          this.setState((prevState) => ({ gridConfig: { ...prevState.gridConfig, gridConfig } }));
        })
        .catch((error) => {
          ResponseHandlerService.error(error);
          gridConfig.rows = [];
          this.setState((prevState) => ({ gridConfig: { ...prevState.gridConfig, gridConfig } }));
        }),
      'loading-tab-backup'
    );
  }

  /* 
    Estatus 1 - Confirmado
    Estatus 2 - Rechazado
    Estatus 3 - Cancelado
    Estatus 4 - Finalizado

    [CANCELAR] No se puede cancelar si esta corriendo el periodio de backup o ya termino.
    [RECHAZAR] No se puede rechazar si el periodo de backup empieza mañana o ya termino.
  */

  // Cancela la solicitud de backup
  cancelBackup = (values, backup, setSubmitting) => {
    console.log('cancelBackup', values);

    let request = {
      IdBackup: backup.IdBackup,
      Comentario: values.comment,
      Estatus: 3
    };

    // Notificación - <colaborador> cancelo la solicitud de backup
    let notificationToSend = {
      IdAmbiente: Environment.getCurrent().environmentId,
      URL: '#/configuraperfil',
      IdTipoNotificacion: 135,
      IdEmpleado: backup.IdEmpleadoBackup,
      Parametros: JSON.stringify({ Tab: 6 }),
      Propiedades: JSON.stringify({ colaborador: backup.NombreBackup })
    };

    BackupService.put(request)
      .then((response) => {
        setSubmitting(false);
        this.closeDialog('cancel');
        this.getBackup();
        NotificationsService.post(notificationToSend);
        ResponseHandlerService.success(response);
      })
      .catch((error) => {
        setSubmitting(false);
        ResponseHandlerService.error(error);
      });
  }

  /**
 * Consulta todos los empleados en estatus 'Alta'
 */
  getEmployees = () => {
    EmployeeService.get({ page: 0, size: 0, filter: { estatus: true } })
      .then((response) => {
        let employeesList = response.filter((employee) => employee.IdEmpleado !== this.userInfo.IdEmpleado);
        this.setState({ employeesList });
      })
      .catch(() => { });
  }

  selectBackup = (backup) => {
    this.setState({ selectedBackup: backup });
  }

  showBackupDialog = () => {
    let data = {};
    this.setState({ showBackupDialog: { data, open: true } });
  };

  showCancelDialog = (item) => {
    let data = item ? { ...item[0] } : {};
    console.log('data', data);

    this.setState({ showCancelDialog: { data, open: true } });
  }

  closeDialog = (dialog) => {
    if (dialog === 'backup') {
      this.setState({ showBackupDialog: { data: {}, open: false } });
    } else if (dialog === 'cancel') {
      this.setState({ showCancelDialog: { data: {}, open: false } });
    }
  }

  render() {
    const { employeesList, gridConfig, selectedBackup } = this.state;

    return (
      <>
        <LoadingWrapper area="loading-tab-backup">

          {/* <MUI.Box padding="8px">
          <FiltersExpansion>
            <MUI.Grid container>
              <MUI.Grid item md={3} sm={6} xs={12}>
                <BoxFilter>
                  <MUI.Autocomplete
                    label={i18n.t('GenericMessages.employee')}
                    searchList={employeesList}
                    searchBy="Nombre"
                    value={''}
                  onChange={(newEmployee) => this.updateFilters({
                    employee: newEmployee,
                    // status: filters.status
                  })}
                  />
                </BoxFilter>
              </MUI.Grid>
              <MUI.Grid item md={3} sm={6} xs={12}>
                <BoxFilter>
                  <MUI.TextField
                    select
                    label={i18n.t('GenericMessages.status')}
                    type="text"
                    name="status"
                  value={filters.status}
                    onChange={(event) => this.updateFilters({
                      //employee: filters.employee,
                      status: event.target.value
                    })}
                  >
                    <MUI.SelectOption value={0}>
                      {i18n.t('GenericMessages.all')}
                    </MUI.SelectOption>
                    <MUI.SelectOption value={1}>
                      {i18n.t('StatusText.active')}
                    </MUI.SelectOption>
                    <MUI.SelectOption value={2}>
                      {i18n.t('StatusText.toBeApproved')}
                    </MUI.SelectOption>
                    <MUI.SelectOption value={3}>
                      {i18n.t('StatusText.approved')}
                    </MUI.SelectOption>
                    <MUI.SelectOption value={4}>
                      {i18n.t('StatusText.rejected')}
                    </MUI.SelectOption>
                  </MUI.TextField>
                </BoxFilter>
              </MUI.Grid>
            </MUI.Grid>
          </FiltersExpansion> 
        </MUI.Box>*/}
          <ContentWrapper>
            <MUI.Grid container>
              {/* Backup */}
              <MUI.Grid item sm={8} xs={12}>
                <BoxContainer>
                  <DataGrid
                    columns={gridConfig.columns}
                    rows={gridConfig.rows}
                    canAdd={gridConfig.canAdd}
                    canEdit={gridConfig.canEdit}
                    canDelete={gridConfig.canDelete}
                    canSelect={gridConfig.canSelect}
                    canSort={true}
                    isPaginated={true}
                    onAdd={() => this.showBackupDialog()}
                    onClickRow={(item) => this.selectBackup(item)}
                  />
                </BoxContainer>
              </MUI.Grid>
              {/* Comentarios de Backup */}
              <MUI.Grid item sm={4} xs={12}>
                <BoxContainer>
                  <FlexCommentsInfo>
                    <Icons.Info />
                    <Typography.Text>
                      Selecciona a una asignación de backup para obtener más información
                    </Typography.Text>
                  </FlexCommentsInfo>
                  <MUI.Box padding="8px">
                    {(selectedBackup.length !== 0 && selectedBackup[0].Comentarios) && (
                      <>
                        {selectedBackup[0].Comentarios.map((item, index) => {
                          return (
                            <CommentLog
                              key={index}
                              photo={item.FotoComentario}
                              name={item.NombreComentario}
                              date={item.Fecha}
                              comment={item.Comentario}
                            />
                          );
                        })}
                        <FlexCommentsActions>
                          <MUI.ButtonCTA
                            type="button"
                            color="secondary"
                            disabled={selectedBackup[0].IdEstatus !== 1}
                            onClick={() => this.showCancelDialog(selectedBackup)}
                          >
                            {i18n.t('DialogConfirm.cancel')}
                          </MUI.ButtonCTA>
                        </FlexCommentsActions>
                      </>
                    )}
                  </MUI.Box>
                </BoxContainer>
              </MUI.Grid>
            </MUI.Grid>
          </ContentWrapper>
        </LoadingWrapper>

        {/* Modal para añadir un backup */}
        {this.state.showBackupDialog.open ? (
          <BackupDialog
            open={this.state.showBackupDialog.open}
            onClose={() => this.closeDialog('backup')}
            getBackup={() => this.getBackup()}
          />
        ) : null}

        {/* Modal para cancelar un backup */}
        {this.state.showCancelDialog.open ? (
          <CancelDialog
            data={this.state.showCancelDialog.data}
            open={this.state.showCancelDialog.open}
            onClose={() => this.closeDialog('cancel')}
            onCancelBackup={this.cancelBackup}
          />
        ) : null}
      </>
    );
  }
}

// *************************************
// STYLED COMPONENTS                               
// *************************************

const ContentWrapper = styled.section`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 8px;
  //border: 1px solid ${(props) => props.theme.colors.greyLight};
  //border-radius: 6px;
  //box-shadow: ${(props) => props.theme.shadows.depth1};
`;

const BoxContainer = styled.div`
  padding: 16px;
  margin: 8px;
  border: 1px solid ${(props) => props.theme.colors.greyLight};
  border-radius: 6px;
  box-shadow: ${(props) => props.theme.shadows.depth1};
`;

const FlexCommentsInfo = styled.div`
  display: flex;
  align-items: center;
  height: 78px;
  padding: 8px;
  border-bottom: 1px solid ${(props) => props.theme.colors.greyLight};

  .MuiSvgIcon-root {
    margin-right: 8px;
    font-size: 20px;
  }
`;

const FlexCommentsActions = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 8px;
`;

export default Backup;